import styled from '@emotion/styled'

import { Color, theme } from '../../constants'
import { useTranslations } from '../../translate'

const Indicator = styled.span<{ requiredByDefault: boolean }>((props) => {
  return {
    color: props.requiredByDefault ? Color.DARKEST_MEDIUM_GREY : Color.RED,
    fontSize: props.requiredByDefault ? theme.font.size[6] : undefined,
    fontWeight: props.requiredByDefault
      ? theme.font.weight.book
      : theme.font.weight.bold,
  }
})

export type RequiredIndicatorProps = {
  required: boolean
  requiredByDefault?: boolean
}

export const RequiredIndicator = (props: RequiredIndicatorProps) => {
  const t = useTranslations()

  const showIndicator = props.requiredByDefault
    ? !props.required
    : props.required

  return showIndicator ? (
    <Indicator requiredByDefault={!!props.requiredByDefault}>
      {' '}
      {props.requiredByDefault ? `(${t.form.optional()})` : '*'}
    </Indicator>
  ) : null
}
